import type { SVGProps } from 'react';

const SvgUserManagerMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M3 21C3 17 5.5 11.5 12 11M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.9999 19.5C18.1045 19.5 18.9999 18.6046 18.9999 17.5C18.9999 16.3954 18.1045 15.5 16.9999 15.5M16.9999 19.5C15.8953 19.5 14.9999 18.6046 14.9999 17.5C14.9999 16.3954 15.8953 15.5 16.9999 15.5M16.9999 19.5V21.5M16.9999 15.5V13.5M15.3035 16.4401L13.6074 15.3803M20.3918 19.6196L18.6957 18.5598M18.6958 16.4401L20.3919 15.3803M13.6075 19.6196L15.3036 18.5598'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
    />
  </svg>
);
export default SvgUserManagerMd;
